import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomInfoboxformComponent } from './custom-infoboxform.component';
import {CustomIconsModule} from "../../../icons/custom-icons.module";

@NgModule({
  declarations: [CustomInfoboxformComponent],
  exports: [
    CustomInfoboxformComponent
  ],
  imports: [
    CommonModule,
    CustomIconsModule
  ]
})
export class CustomInfoboxformModule { }
